import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/pro-regular-svg-icons/faQuestion';
var FontIconWithDefault = function (_a) {
    var icon = _a.icon, icons = _a.icons, size = _a.size, _b = _a.color, color = _b === void 0 ? undefined : _b, _c = _a.style, style = _c === void 0 ? undefined : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { return null; } : _d;
    var selectedIcon = icons[icon] ? icons[icon] : faQuestion;
    var selectedSize = size || '2x';
    return (_jsx(FontAwesomeIcon, { size: selectedSize, icon: selectedIcon || faQuestion, color: color, style: style, onClick: onClick }));
};
export default FontIconWithDefault;
